import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface ICouponSectionProps {
  $bgColor?: string;
  $textColor?: string;
}

export const CouponSection3 = styled.div<ICouponSectionProps>`
  padding: 32px 20px;
  text-align: center;
  background: #fff;

  &.bg-type-black {
    background: #000;

    .main-title {
      color: #fff;
    }

    .basic-btn {
      color: #fff;
      border-color: #555;

      svg path {
        fill: #fff;
      }
    }
  }

  ${({ $bgColor, $textColor }) =>
    ($bgColor || $textColor) &&
    css`
      background-color: ${$bgColor};

      .basic-btn {
        color: ${$textColor};

        svg path {
          fill: ${$textColor};
        }
      }
    `}

  .section-title {
    padding-left: 0;
    padding-right: 0;
  }

  .text {
    text-align: left;
  }

  .coupon-wrap {
    margin-bottom: 20px;

    .item + .item {
      margin-top: 8px;
    }
  }

  .basic-btn {
    background: transparent;
  }

  .event-notice {
    padding-top: 20px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('32 20')};

    .coupon-wrap {
      margin-bottom: ${mixin.pxToVw('20')};

      .item + .item {
        margin-top: ${mixin.pxToVw('8')};
      }
    }

    .event-notice {
      padding-top: ${mixin.pxToVw('20')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 65px 57px;

    .coupon-wrap {
      ${mixin.flex({
        wrap: 'wrap',
        justify: 'center',
      })};
      gap: 18px;
      margin: 0;

      .item + .item {
        margin-top: 0;
      }

      .coupon-item.type-count {
        width: 430px;

        .text-wrap {
          width: calc(100% - 80px);
          padding: 19px 46px 19px 24px;

          &:before,
          &:after {
            right: 75.5px;
          }
        }

        .btn {
          width: 80px;
        }
      }
    }

    .basic-btn {
      width: 430px;
      height: 48px;
      margin-top: 48px;
    }

    .event-notice {
      padding-top: 30px;
    }
  }
`;
